var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48326 14.0819C8.80106 13.8901 9.19894 13.8901 9.51674 14.0819L13.151 16.2754C13.9083 16.7325 14.8425 16.0535 14.6416 15.192L13.6771 11.0578C13.5928 10.6963 13.7156 10.3178 13.9962 10.0748L17.2086 7.29189C17.8772 6.71268 17.5198 5.61442 16.6384 5.53964L12.4109 5.18098C12.0413 5.14962 11.7194 4.91629 11.5747 4.57479L9.92072 0.672371C9.57613 -0.140657 8.42387 -0.140659 8.07928 0.672369L6.42532 4.57479C6.28058 4.91629 5.95871 5.14962 5.58914 5.18098L1.36163 5.53964C0.480202 5.61442 0.122796 6.71268 0.791394 7.29189L4.00379 10.0748C4.28436 10.3178 4.40721 10.6963 4.32287 11.0578L3.35841 15.192C3.15745 16.0535 4.09168 16.7325 4.849 16.2754L8.48326 14.0819Z",
    fill: "#FAAD14"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarColor);
export default __webpack_public_path__ + "static/media/star-color.f39cd9c5b8b32f7b4888304d12009961.svg";
export { ForwardRef as ReactComponent };